const highlights = [
  { icon: "ri-heart-pulse-line", title: "Medical-Grade Steel", desc: "SS304 & SS316 stainless steel meeting international healthcare hygiene standards." },
  { icon: "ri-ruler-2-line", title: "Fully Custom-Built", desc: "Every unit fabricated to your exact floor plan, workflow, and storage requirements." },
  { icon: "ri-shield-check-line", title: "Certified Fabrication", desc: "All equipment complies with Kenya health facility regulations and ISO standards." },
  { icon: "ri-tools-line", title: "End-to-End Service", desc: "Survey, design, fabrication, delivery, installation, and after-sales maintenance." },
];

export default function HospitalOverview() {
  return (
    <section id="overview" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <img
              src="/images/hospital/nurse-station.webp"
              alt="Hospital equipment fabrication"
              className="w-full h-[420px] object-cover object-top rounded-lg"
            />
            <div className="absolute -bottom-6 -right-6 bg-teal-600 rounded-lg p-6 shadow-lg">
              <p className="text-white text-3xl font-extrabold">200+</p>
              <p className="text-teal-100 text-xs uppercase tracking-wider mt-1">Healthcare Facilities Served</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="text-teal-600 text-xs font-bold uppercase tracking-widest">Who We Are</span>
            <h2 className="text-gray-900 text-3xl md:text-4xl font-extrabold mt-3 mb-6 leading-tight uppercase">
              Kenya's Trusted Medical Equipment Fabricators
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              ISMAN Engineering has been serving Kenya's healthcare sector for over 15 years, delivering
              precision-fabricated stainless steel equipment to hospitals, pharmacies, clinics, and
              health centres across the country. Our team of certified engineers and fabricators
              understand the unique hygiene, durability, and compliance requirements of medical environments.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              From busy outpatient pharmacy counters to sterile theatre instrument trolleys, we design,
              build, and install bespoke solutions that enhance workflow, meet infection-control standards,
              and stand up to decades of daily use.
            </p>

            {/* Highlights grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {highlights.map((h) => (
                <div key={h.title} className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg border border-gray-100">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0">
                    <i className={`${h.icon} text-lg text-teal-600`}></i>
                  </div>
                  <div>
                    <p className="text-gray-900 text-xs font-bold uppercase tracking-wide">{h.title}</p>
                    <p className="text-gray-500 text-xs mt-1 leading-relaxed">{h.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
